import { $createImageNode, ImageNode } from '@atlas/lexical-core';
import {
  COMMAND_PRIORITY_NORMAL,
  createCommand,
  type LexicalCommand,
  type LexicalEditor,
} from 'lexical';
import { $insertNodesAndSplitList } from '../../utils';
import type { Gif } from './klipy';

const MAX_GIF_WIDTH = 400;

export const TRY_INSERT_GIF_COMMAND: LexicalCommand<void> = createCommand(
  'TRY_INSERT_GIF_COMMAND'
);

type GifPickerPluginProps = {
  onOpenPicker: () => void;
};

function registerGifPickerPlugin(
  editor: LexicalEditor,
  props: GifPickerPluginProps
) {
  return editor.registerCommand(
    TRY_INSERT_GIF_COMMAND,
    () => {
      // iOS can clear the Lexical selection on the tap that chose /gif
      // before this command runs. The picker still opens; insert restores
      // the caret or falls back to the end of the document.
      props.onOpenPicker();
      return true;
    },
    COMMAND_PRIORITY_NORMAL
  );
}

export function gifPickerPlugin(props: GifPickerPluginProps) {
  return (editor: LexicalEditor) => registerGifPickerPlugin(editor, props);
}

export function $insertGifNode(gif: Gif) {
  const width = Math.min(gif.width, MAX_GIF_WIDTH);
  const imageNode = $createImageNode({
    srcType: 'url',
    url: gif.url,
    alt: gif.title,
    width: gif.width,
    height: gif.height,
    constrainedWidth: width,
    constrainedHeight: Math.round((width / gif.width) * gif.height),
  });

  $insertNodesAndSplitList([imageNode]);
}

export { ImageNode as GifDependency };
